import { useState } from 'react';
import { signInWithLine } from '@/lib/liff';
import { useNavigate } from 'react-router-dom';

export function OnboardingPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      const { tenantId } = await signInWithLine();
      if (tenantId) {
        navigate('/calendar', { replace: true });
      } else {
        // 初回ユーザー → セットアップフローへ
        // Phase 0 では auth-line Edge Function 側で tenant を自動作成想定
        setError('初回登録は管理者にお問い合わせください。');
      }
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-bold tracking-tight">オーエス</h1>
          <p className="mt-2 text-sm text-slate-600">
            LINE業務を AI で構造化して
            <br />
            board に流すアプリ
          </p>
        </div>

        <button
          type="button"
          onClick={handleLogin}
          disabled={loading}
          className="w-full rounded-lg bg-emerald-500 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-emerald-600 disabled:opacity-50"
        >
          {loading ? '接続中...' : 'LINEでログイン'}
        </button>

        {error && (
          <div className="mt-4 rounded-md bg-rose-50 p-3 text-xs text-rose-700">{error}</div>
        )}

        <div className="mt-8 text-center text-[10px] text-slate-400">
          認証は LIFF 経由のみ
          <br />
          通知は一切しません
        </div>
      </div>
    </div>
  );
}
